/**
 * Where the seconds go between the pill and the face (2026-10-30).
 *
 * "15 seconds to load the avatar" could not be read from any server log:
 * the bot was ready 2 s after the hand-off, the token took 0.6 s, and the
 * rest happened in the visitor's browser — chunk fetches, the Daily join,
 * the face paint. The widget now marks each step and posts ONE
 * `voice-connect-timing` session event per call, so the next report can
 * be read as a breakdown instead of a feeling.
 */

export type ConnectMarks = {
  /** performance.now() when the visitor asked for voice. */
  start: number;
  /** Token response received. */
  token?: number;
  /** Daily chunk resolved (0 when it was preloaded). */
  chunk?: number;
  /** Daily room join completed. */
  join?: number;
  /** The bot participant appeared in the room. */
  bot?: number;
  /** The live face painted (avatar calls). */
  face?: number;
  /** The chunk was already in memory before the click. */
  preloaded: boolean;
};

/** Milliseconds from the click to each step; -1 for a step that never came. */
export function connectTimingPayload(m: ConnectMarks): Record<string, number | boolean> {
  const d = (t?: number): number => (t === undefined ? -1 : Math.max(0, Math.round(t - m.start)));
  return {
    tokenMs: d(m.token),
    chunkMs: d(m.chunk),
    joinMs: d(m.join),
    botMs: d(m.bot),
    faceMs: d(m.face),
    preloaded: m.preloaded,
  };
}
